import * as React from 'react';

import './loading.scss';

export const Loading = () => (
  <div className="padding-50 centered">
    <div className="loader" />
  </div>
);
